import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { MILLISECONDS_IN_MINUTE, MILLISECONDS_IN_SECOND } from "@/lib/format-date"
import { formatDurationToNow, getDurationToNowInHours } from "@/modules/waiting-room/helpers/get-duration-to-now"

const MissedCall = ({ missedCallsCount, lastMissedCallAt }: { missedCallsCount: number; lastMissedCallAt: Date }) => {
  const [durationText, setDurationText] = useState<string>(formatDurationToNow(lastMissedCallAt))
  const { t } = useTranslation()

  useEffect(() => {
    const hour = getDurationToNowInHours(lastMissedCallAt)
    const delayInterval = hour > 0 ? MILLISECONDS_IN_MINUTE : MILLISECONDS_IN_SECOND

    const interval = setInterval(() => setDurationText(formatDurationToNow(lastMissedCallAt)), delayInterval)

    return () => clearInterval(interval)
  }, [missedCallsCount, lastMissedCallAt])

  return (
    <div className="truncate">
      {t("scheduling.waitingRoom.grid.missedCallsCount", {
        lastMissedCallSince: durationText,
        missedCallsCount: missedCallsCount,
      })}
    </div>
  )
}

export { MissedCall }
